import React, {useRef} from 'react';
import style from './index.module.scss';
import {SortOrder} from 'antd/es/table/interface';
import {isTrue} from 'Utils/common';
import Operations from './components/Operations';
import {Button, message, Space} from 'antd';
import {
    deleteTask,
    getTaskPage,
    Status,
    TaskListItem,
    User,
} from '../../../service';
import MultiLineColumn from '../../../Components/MultiLineColumn';
import moment from 'dayjs';
import OverLengthColumn from '../../../Components/OverLengthColumn';
import useSelection from '../../../../../Utils/Hooks/useSelection';
import AddTaskModal from './components/AddTaskModal';
import useModalHandler from '../../../../../Utils/Hooks/useModalHandler';
import {useMutation} from 'react-query';
import useTable from '../../../../../Utils/Hooks/useTable';
import TableRender, {ProColumnsType, TableContext} from 'table-render';
import DeleteConfirm from '../../../../../Components/DeleteConfirm';

export interface searchItem {
    name?: string; //名称及编码
    status?: Status; //启用状态
}

export default function TaskList() {
    const rowSelection = useSelection();
    const {tableInit} = useTable(getTaskPage, {});
    const tableRef = useRef<TableContext>(null);

    function reload() {
        tableRef?.current?.refresh({stay: true});
    }

    const sortDirections: SortOrder[] = ['descend', 'ascend'];
    const columns: ProColumnsType<TaskListItem> = [
        {
            title: '名称及编码',
            dataIndex: 'code',
            align: 'left',
            render: (text: string, record: TaskListItem) => (
                <MultiLineColumn name={record.name} no={text} />
            ),
        },
        {
            title: '创建人',
            dataIndex: 'createUser',
            align: 'center',
            render: (text: User) => (
                <MultiLineColumn
                    name={text.name ? text.name : '系统内置'}
                    no={text.loginName ? text.loginName : 'system'}
                />
            ),
        },
        {
            title: '创建时间',
            dataIndex: 'createTime',
            align: 'center',
            sortDirections: sortDirections,
            sorter: (a, b) => moment(a.createTime).diff(b.createTime),
            render: (text: string) => (
                <div>
                    {text ? moment(text).format('YY-MM-DD HH:mm:ss') : '--'}
                </div>
            ),
        },
        {
            title: '启用状态',
            dataIndex: 'status',
            align: 'center',
            render: (text: Status) => (
                <div>{isTrue(text) ? '已启用' : '已停用'}</div>
            ),
        },
        {
            title: '更新人',
            dataIndex: 'updateUser',
            align: 'center',
            render: (text: User) => (
                <MultiLineColumn name={text.name} no={text.loginName} />
            ),
        },
        {
            title: '更新时间',
            dataIndex: 'updateTime',
            align: 'center',
            sortDirections: sortDirections,
            sorter: (a, b) => moment(a.updateTime).diff(b.updateTime),
            render: (text: string) => (
                <div>
                    {text ? moment(text).format('YY-MM-DD HH:mm:ss') : '--'}
                </div>
            ),
        },
        {
            title: '说明',
            dataIndex: 'description',
            align: 'center',
            render: (text: string) => <OverLengthColumn value={text} />,
        },
        {
            title: '分类',
            dataIndex: 'className',
            align: 'center',
        },
        {
            title: '操作',
            width: 250,
            align: 'center',
            fixed: 'right',
            render: (text: string, record: TaskListItem) => (
                <Operations record={record} updateData={() => reload()} />
            ),
        },
    ];

    const schema = {
        type: 'object',
        labelWidth: 130,
        properties: {
            name: {
                title: '名称及编号',
                type: 'string',
            },
            status: {
                title: '启用状态',
                type: 'string',
                widget: 'select',
                props: {
                    options: [
                        {label: '全部', value: ''},
                        {label: '已启用', value: Status.Open},
                        {label: '已停用', value: Status.Close},
                    ],
                },
            },
        },
    };

    const onDelete = useMutation({
        mutationFn: deleteTask,
        onSuccess: () => {
            message.success('成功!');
            rowSelection.clear();
            reload();
        },
    });
    const addModal = useModalHandler({
        component: AddTaskModal,
    });
    const toolBar = (
        <Space>
            <Button
                type="primary"
                onClick={() =>
                    addModal.open({
                        flag: 'add',
                        updateData: () => {
                            addModal.close();
                            reload();
                        },
                    })
                }>
                新增调度任务
            </Button>
            <DeleteConfirm
                onSuccess={() => onDelete.mutate(rowSelection.selected.join())}>
                <Button disabled={rowSelection.isEmpty} danger ghost>
                    批量删除
                </Button>
            </DeleteConfirm>
        </Space>
    );

    return (
        <div className={style.root}>
            <TableRender
                columns={columns}
                rowKey="id"
                toolbarRender={toolBar}
                search={{schema}}
                rowSelection={rowSelection}
                ref={tableRef}
                {...tableInit()}
            />
            {addModal.render()}
        </div>
    );
}
